import {FETCH_POSTS,
      //  FETCH_QTD_COMENTARIOS,
        FETCH_LISTAR_COMENTARIOS_POST,
        FETCH_TURMA_PROFESSOR,
        FETCH_RANKING_CURSO,
        ID_TURMA_PROFESSOR,
        REMOVER_COMENTARIO,
        ADD_POST,
        ADD_LIKE,
        REMOVER_POST,
        ADD_COMENTARIO
        } from '../actions/turmaAction';

const INITIAL_STATE = { 
                        all_posts         : [],
                        turma             : false,
                        curso             : false,
                        allComentPost     : [],
                        allProfessorTurma : [],
                        fetch_all_turma   : [],
                        allRankingCurso   : [],
                        qtdComent         : "",
                        post              : null,
                        fetch_tur_id      : null
                      };

export default function(state = INITIAL_STATE,action){

    switch (action.type) {
        case FETCH_POSTS:
          
            return {
                    all_posts : (action.payload.data?action.payload.data.posts:[]),
                    turma     : action.payload.data.turma,
                    curso     : action.payload.data.curso
                } 

        case FETCH_LISTAR_COMENTARIOS_POST:
          
           return { ...state, allComentPost:action.payload.data }
       
        case FETCH_TURMA_PROFESSOR:
          
           return { ...state, allProfessorTurma:action.payload.data }  
        
         case FETCH_RANKING_CURSO:
           return { ...state, allRankingCurso:action.payload.data }
    

        case ID_TURMA_PROFESSOR:
         
           return { ...state, fetch_tur_id:action.fetch_tur_id }  

        case ADD_COMENTARIO:

            const response        = action.payload[0].data;
            const qtd_comentarios = action.payload[1].data;
            const comentario      = {
                                    tur_com_pos_id             :response.comentario.tur_com_pos_id,
                                    tur_com_pos_cod_turma_post :response.comentario.tur_com_pos_cod_turma_post,
                                    tur_com_pos_cod_usuario    :response.comentario.tur_com_pos_cod_usuario,
                                    tur_com_pos_comentario     :response.comentario.tur_com_pos_comentario,
                                    tur_com_pos_flag_ativo     :response.comentario.tur_com_pos_flag_ativo,
                                    created_at                 :response.comentario.created_at,
                                    updated_at                 :response.comentario.updated_at,
                                    use_email                  :response.usuario.use_email,
                                    use_foto                   :response.usuario.use_foto,
                                    use_id                     :response.usuario.use_id,
                                    use_login                  :response.usuario.use_login,
                                    use_nome                   :response.usuario.use_nome
                                    }
      
            const filtroQtdComentarioPost =  state.all_posts.filter((item) =>{
                    if (item.tur_pos_id === response.comentario.tur_com_pos_cod_turma_post) {
                        return  item.qtd_comentarios = qtd_comentarios;
                    }else{
                        return item.tur_pos_id;
                    }
                });  
                    
            return { ...state, 
                    allComentPost: [comentario,...state.allComentPost],
                    all_posts:filtroQtdComentarioPost }
       
        case ADD_POST:
           
            const post = {
                            created_at          : action.payload.data.post.created_at,
                            like_usuario        : 0,
                            likes               : false,
                            num_like            : 0,
                            qtd_comentarios     : 0,
                            tur_pos_cod_turma   : action.payload.data.post.tur_pos_cod_turma,
                            tur_pos_cod_usuario : action.payload.data.post.tur_pos_cod_usuario,
                            tur_pos_flag_ativo  : 1,
                            tur_pos_id          : action.payload.data.post.tur_pos_id,
                            tur_pos_midia       : action.payload.data.post.tur_pos_midia,
                            tur_pos_post        : action.payload.data.post.tur_pos_post,
                            tur_pos_tipo        : action.payload.data.post.tur_pos_tipo,
                            updated_at          : action.payload.data.post.updated_at,
                            use_email           : action.payload.data.usuario.use_email,
                            use_foto            : action.payload.data.usuario.use_foto,
                            use_id              : action.payload.data.usuario.use_id,
                            use_nome            : action.payload.data.usuario.use_nome,


                        }
            return { ...state, 
                           all_posts: [post,...state.all_posts]
                            
                        }
        case ADD_LIKE:
           
            const filtro = state.all_posts.filter((item) =>{
                if (item.tur_pos_id === action.payload.data.id_post) {
                    
                    if (action.payload.data.status>0) {
                       item.num_like = action.payload.data.qtd_likes;
                       return item.like_usuario = 1;
                    } else {
                        item.num_like = action.payload.data.qtd_likes;
                        return  item.like_usuario ="0"; 
                    }
                }else{
                    return item.tur_pos_id;
                }
                
            }) 
           return { ...state, all_posts : filtro }

        case REMOVER_POST:

            return { ...state, all_posts : state.all_posts.filter(item => item.tur_pos_id !== action.payload) }
                           
        case REMOVER_COMENTARIO:
   
            const dadosComentario = action.payload[0];
         
           // const dadosQtdComentario = action.payload[1].data;
           
            //Acao para filtrar o array de post se o id do post for igual ao id do payload, atualize a quantidade de comentarios                    
            const filtroRemoveComentarioPost = state.all_posts.filter((item) =>{
                if (item.tur_pos_id === dadosComentario.tur_com_pos_cod_turma_post) {
                     return item.qtd_comentarios = (item.qtd_comentarios===1 ? "0" : item.qtd_comentarios-1);
                }else{
                   return item.tur_pos_id;
                }
            });   
        
            return { ...state, allComentPost : state.allComentPost.filter(item => item.tur_com_pos_id !== dadosComentario.tur_com_pos_id)
                             ,all_posts:filtroRemoveComentarioPost}
    
        default:
           return state;
    }

}


// WEBPACK FOOTER //
// ./src/reducers/reducer_turma.js